import React, { useState } from 'react';
import { Button, IconButton, Typography, Box } from '@mui/material';
import { Toolbar } from 'components';
import { Person, Edit, Delete } from '@mui/icons-material';
import styled from 'styled-components';

const EditorialToolbar = ({
	totalSelected,
	selectedIds,
	selected,
	handleClear
}) => (
	<Toolbar open={selectedIds?.length > 0} handleClose={handleClear}></Toolbar>
);

export default EditorialToolbar;

const StyledButton = styled(Button)`
	margin-right: 10px;
`;
